import React from 'react'

export function renderLinks(text) {
  if (!text) return null

  const regex = /\[([^\]]+)\]\((https?:\/\/[^\s]+?)\)/g
  const parts = []
  let lastIndex = 0
  let match

  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, linkText, url] = match
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    parts.push(
      React.createElement('a', {
        key: match.index,
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        style: { color: '#e76622', textDecoration: 'underline', fontWeight: 600 }
      }, linkText)
    )
    lastIndex = match.index + fullMatch.length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts.flatMap((part, i) => {
    if (typeof part !== 'string') return [part]
    return part.split('\n').flatMap((line, j, arr) =>
      j < arr.length - 1
        ? [line, React.createElement('br', { key: 'br-' + i + '-' + j })]
        : [line]
    )
  })
}
